import { render, staticRenderFns } from "./kw_carousel.vue?vue&type=template&id=2a4b9e0c&scoped=true&"
import script from "./kw_carousel.vue?vue&type=script&lang=js&"
export * from "./kw_carousel.vue?vue&type=script&lang=js&"
import style0 from "./kw_carousel.vue?vue&type=style&index=0&id=2a4b9e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b9e0c",
  null
  
)

component.options.__file = "kw_carousel.vue"
export default component.exports